export default __webpack_public_path__ + "static/media/pic8.b674928d.jpg";